// Conversiones de negocio confirmadas por el servidor (auditoría de analítica oct-2026, planes 35–38).
// Llegan en un elemento `conversion-analitica` (flash de una sola lectura o la propia respuesta) o en
// el JSON de un `fetch`. Aquí se garantiza lo que el servidor no puede:
//   - que el «atrás» de Turbo, que vuelve a ejecutar el HTML de su caché, no las repita (id en sessionStorage);
//   - que no se empujen antes de que Didomi publique el consentimiento: GTM evalúa cada evento una vez
//     y, sin `didomiVendorsConsent`, la etiqueta no salta (`consentimiento_en_gtm.js`);
//   - que el modelo de datos de GTM no herede el objeto en el evento siguiente (limpieza tras el push).
import { cuandoGtmConozcaElConsentimiento } from 'lib/consentimiento_en_gtm'

const CLAVE_ENVIADAS = 'rnk_conversiones_enviadas'
const MAXIMO_RECORDADAS = 50
const enviadasEnEstaPagina = new Set()

function leeEnviadas () {
  try { return JSON.parse(window.sessionStorage.getItem(CLAVE_ENVIADAS)) || [] } catch { return [] }
}

function yaEnviada (id) {
  return enviadasEnEstaPagina.has(id) || leeEnviadas().includes(id)
}

function marcaEnviada (id) {
  enviadasEnEstaPagina.add(id)
  try {
    window.sessionStorage.setItem(CLAVE_ENVIADAS, JSON.stringify([...leeEnviadas(), id].slice(-MAXIMO_RECORDADAS)))
  } catch { /* sin sessionStorage basta la memoria de esta página */ }
}

export function empujaConversion (conversion, { esperaAlConsentimiento = true } = {}) {
  const { id, evento, datos = {} } = conversion || {}
  if (!id || !evento || yaEnviada(id)) return false

  marcaEnviada(id)
  cuandoGtmConozcaElConsentimiento(() => {
    window.dataLayer = window.dataLayer || []
    if ('ecommerce' in datos) window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({ event: evento, ...datos })
    window.dataLayer.push(Object.fromEntries(Object.keys(datos).map((clave) => [clave, undefined])))
  }, esperaAlConsentimiento)
  return true
}

export function empujaConversiones (conversiones, opciones) {
  return (Array.isArray(conversiones) ? conversiones : []).map((conversion) => empujaConversion(conversion, opciones))
}

// Para los formularios que envían por fetch y siguen el redirect (artefactos de promociones, plan 36):
// la respuesta final es el HTML de la página de gracias, con el elemento ya pintado.
export function empujaConversionesDesdeHtml (html) {
  try {
    const documento = new window.DOMParser().parseFromString(String(html), 'text/html')
    documento.querySelectorAll('[data-controller~="conversion-analitica"]').forEach((elemento) => {
      empujaConversiones(JSON.parse(elemento.dataset.conversionAnaliticaConversionesValue || '[]'),
        { esperaAlConsentimiento: elemento.dataset.conversionAnaliticaEsperaAlConsentimientoValue !== 'false' })
    })
  } catch { /* la analítica no rompe el flujo que mide */ }
}

window.RankiaConversiones = { empujaConversiones, desdeHtml: empujaConversionesDesdeHtml }
